import type {PageType} from './types';

const ANALYTICS_PAGE_KEY = 'analytics';
const SOURCES_PAGE_KEY = 'sources';
const VISITORS_PAGE_KEY = 'visitors';
const LEAD_ATTRIBUTION_PAGE_KEY = 'lead-attribution';
const CONNECTED_FORMS_PAGE_KEY = 'connected-forms';
const CHAT_PAGE_KEY = 'chat';

const PAGE_TYPE_CONFIG = {
    [ANALYTICS_PAGE_KEY]: {
        name: 'Analytics',
        activeText: 'Nutshell will track the activity of anyone who visits your site.',
    },
    [SOURCES_PAGE_KEY]: {
        name: 'Channels and sources',
        activeText:
            'Channels and sources will be automatically added to leads that come in through your website.',
    },
    [VISITORS_PAGE_KEY]: {
        name: 'VisitorIQ',
        activeText:
            'VisitorIQ will keep track of any company that visits your website, whether or not they submit a form.',
    },
    [LEAD_ATTRIBUTION_PAGE_KEY]: {
        name: 'Lead attribution',
        activeText:
            'Channels and sources will be automatically added to leads that come in through your website.',
    },
    [CONNECTED_FORMS_PAGE_KEY]: {
        name: 'Connected forms',
        activeText:
            'Nutshell will track the activity of anyone who fills out an active form on your website.',
    },
    [CHAT_PAGE_KEY]: {
        name: 'Chat',
        activeText: 'Your chat widget will be visible to your website visitors.',
    },
} as const;

export const getNamedFeature = (pageType: PageType): string => {
    return PAGE_TYPE_CONFIG[pageType].name;
};

export const getActiveText = (pageType: PageType): string => {
    return PAGE_TYPE_CONFIG[pageType].activeText;
};
